/* eslint-disable */
import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, setToken } from '@/utils/auth';
// import router from '@/router';
// import store from '@/store';

var deployversion = null;
// Create axios instance
const service = axios.create({
  baseURL: '',
  timeout: 10000, // Request timeout
});

// Request intercepter
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + getToken(); // Set JWT token
    }

    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    console.log('hhheader');
    console.log(response);
    // deployversion dans data force a changer le header
    if (response.data && response.data.data && response.data.data.deployversion) {
        console.log('data deployversion: ' + response.data.data.deployversion);
    }
    if (response.headers.deployversion) {
        console.log('header deployversion: ' + response.headers.deployversion);
        console.log('this deployversion: ' + deployversion);
        console.log(Number(response.headers.deployversion) > Number(deployversion));
        if (deployversion === null){
          console.log('lo pillo');
          deployversion = response.headers.deployversion;
        } else if (Number(response.headers.deployversion) > Number(deployversion)){
          console.log('reload');
          window.location.reload();
          //store.dispatch("user/logout");
          //router.push(`/login?redirect=${this.$route.fullPath}`);
        }
      }

    if (response.headers.authorization) {
      setToken(response.headers.authorization);
      response.data.token = response.headers.authorization;
    }

    return response.data;
  },
  error => {
    console.log('eeeeerrrror');
    console.log(error.response);
    console.log(error.message);
    //service unavailable
    // pour maintenance
    //à enlever
    if(error.response.status == 503){
        window.location.reload();
    }
   let message = error.message;
    if (error.response.data && error.response.data.errors) {
      // message = error.response.data.errors;
      // messages dans validation form
      message = "erreurs dans les champs";
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }

    Message({
      message: message,
      type: 'error',
      duration: 1 * 3000,
    });
    return Promise.reject(error);
  },
);

export default service;
